import React from 'react';

const LoadingSpinner = ({ size = 'md', text = '', className = '' }) => {
  const sizes = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 border-accent ${sizes?.[size]}`} />
      {text && (
        <p className="text-muted-foreground mt-4 text-sm">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;